import { inject, NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { AuthGuard, hasCustomClaim, redirectUnauthorizedTo, redirectLoggedInTo, idTokenResult } from '@angular/fire/auth-guard';
import { TopLevelStructureComponent } from './top-level-structure/top-level-structure.component';
import { TopLevelLayoutComponent } from './top-level-layout/top-level-layout.component';
import { ChangePasswordComponent } from './login-widget/change-password/change-password.component';
import { LoginComponent } from './login-widget/login/login.component';
import { ForgotPasswordComponent } from './login-widget/forgot-password/forgot-password.component';
import { ErrorComponent } from './error/error.component';
import { map, pipe } from 'rxjs';
import { CurrentClientService } from './services/current-client.service';
import { VerifyEmailComponent } from './login-widget/verify-email/verify-email.component';
import { LogoutComponent } from './login-widget/logout/logout.component';
import { CookiesErrorComponent } from './cookies-error/cookies-error.component';

let currentClientService: CurrentClientService;
const redirectUnauthorizedToLoginAuthPipe = () => pipe(idTokenResult, map(idTokenResult => {
  if(!idTokenResult){
    return currentClientService.routePrefix + "/login";
  }
  else{
    return true;
  }  
}));

const dispatchAuthPipe = () => pipe(idTokenResult, map(idTokenResult => {
  const isSsoAdmin = idTokenResult.claims["isSsoAdmin"];
  let relativePath:string;
  
  if(currentClientService.initialRoute){
    relativePath = currentClientService.initialRoute;
    currentClientService.clearInitialRoute();
  }
  else if(isSsoAdmin){
    relativePath = currentClientService.routePrefix + "/user/my-apps";
  }
  else{
    relativePath = currentClientService.routePrefix + "/user/my-apps"
  }

  return relativePath;
}));

const adminOnlyAuthPipe = () => pipe(idTokenResult, map(idTokenResult => {
  const isSsoAdmin = idTokenResult.claims["isSsoAdmin"];

  if (isSsoAdmin) {
    return true;
  } else {
    return currentClientService.routePrefix;
  }
}));


const routes: Routes = [
  { path: '', 
    redirectTo: 'app', 
    pathMatch: 'full'
  },
  {
    path: 'app/:appId',
    canActivate: [AuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLoginAuthPipe
    },
    component: TopLevelStructureComponent,
    children: [
      {
        path: '',
        component: TopLevelLayoutComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'dispatch'
          },
          {
            path: 'user',
            loadChildren: () => import('./user/user.module').then(module => module.UserModule),
          },
          {
            path: 'admin',
            loadChildren: () => import('./admin/admin.module').then(module => module.AdminModule),
            canActivate: [AuthGuard],
            data: {
              authGuardPipe: adminOnlyAuthPipe
            }
          },
          {
            path: 'dispatch',
            canActivate: [AuthGuard],
            data: {
              authGuardPipe: dispatchAuthPipe
            },
            children:[]
          }
        ]
      }
    ]
  },
  {
    path: 'app/:appId/login',
    component: LoginComponent
  },
  {
    path: 'app/:appId/logout',
    component: LogoutComponent
  },
  {
    path: 'app/:appId/forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'app/:appId/change-password/:id',
    component: ChangePasswordComponent,
  },
  {
    path: 'app/:appId/verify-email/:token',
    component: VerifyEmailComponent,
  },
  {
    path: 'app/:appId/cookies-required',
    canActivate: [() => {
      const router = inject(Router);
      if (navigator.cookieEnabled) {
        return router.navigate([`${currentClientService.routePrefix}/user/my-apps`]);
      } else {
        return true;
      } 
    }],
    component: CookiesErrorComponent,
  },
  {
    path: "**",
    component: ErrorComponent,
    data: { errorPageShown: true },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(
    public cCS: CurrentClientService
  )
  {
    currentClientService = cCS;
  }
 }
